import { Col, Row, Space, Typography } from "antd";
import { PERSON_1 } from "assets";

const OurTeam = () => {
  return (
    <section className="our-team-section section-margin-top">
      <div className="container">
        <Typography.Title level={2}>Our Expert Team</Typography.Title>
        <Row gutter={[20, 20]}>
          <Col xs={12} sm={8} md={6} lg={6} xl={6}>
            <TeamMember
              image={PERSON_1}
              name="Hennie Stander"
              position="CEO at HSC Engineering"
            />
          </Col>
          <Col xs={12} sm={8} md={6} lg={6} xl={6}>
            <TeamMember
              image={PERSON_1}
              name="Hennie Stander"
              position="CEO at HSC Engineering"
            />
          </Col>
          <Col xs={12} sm={8} md={6} lg={6} xl={6}>
            <TeamMember
              image={PERSON_1}
              name="Hennie Stander"
              position="CEO at HSC Engineering"
            />
          </Col>
          <Col xs={12} sm={8} md={6} lg={6} xl={6}>
            <TeamMember
              image={PERSON_1}
              name="Hennie Stander"
              position="CEO at HSC Engineering"
            />
          </Col>
          <Col xs={12} sm={8} md={6} lg={6} xl={6}>
            <TeamMember
              image={PERSON_1}
              name="Hennie Stander"
              position="CEO at HSC Engineering"
            />
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default OurTeam;

const TeamMember = ({ image, name, position }) => (
  <div className="team-member">
    <img src={image} alt={name} />
    <div className="team-member-details">
      <Space direction="vertical" size={1}>
        <Typography.Text className="font-chakra font-bold m-0">
          {name}
        </Typography.Text>
        <Typography.Text className="font-chakra font-12 m-0">
          {position}
        </Typography.Text>
      </Space>
    </div>
  </div>
);
